import { Tooltip, withStyles } from '@material-ui/core';

export const TransparentTooltip = withStyles(() => ({
  tooltip: {
    backgroundColor: 'transparent',
    color: 'transparent',
    boxShadow: 'none',
    padding: 0,
    border: 'none',
    borderRadius: '8px',
  },
  arrow: {
    color: 'transparent',
  },
}))(Tooltip);